import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from '../injection-tokens';
import { PaginatedInvoiceOverview } from '../models/invoice-overview.model';
import { InvoiceOverviewQuery } from '../models/invoice-overview-query.model';

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  private readonly httpClient = inject(HttpClient);

  private readonly apiBaseUrl = inject(API_BASE_URL);

  getInvoiceOverview(query: InvoiceOverviewQuery): Observable<PaginatedInvoiceOverview> {
    return this.httpClient.post<PaginatedInvoiceOverview>(`${this.apiBaseUrl}/v1/invoices/overview`, query);
  }

  getInvoiceDetailCsv(month: number, year: number): Observable<Blob> {
    return this.httpClient.get(`${this.apiBaseUrl}/v1/invoices/details/${year}/${month}/csv`, {
      responseType: 'blob',
    });
  }
}
